module.exports = __webpack_public_path__ + "img/aerial_booths.b6d6b286.png";